import { useQuery } from "@tanstack/react-query";
import { listModels } from "@/lib/api";
import { queryKeys } from "@/lib/cache/queryKeys";
import { staleTimes } from "@/lib/cache/staleTimes";

export function useModels() {
  return useQuery({
    queryKey: queryKeys.models,
    queryFn: listModels,
    staleTime: staleTimes.models,
  });
}
